import React from 'react';
import request from 'superagent/lib/client';
import { Link } from 'react-router-dom';
import config from '../../config';
import { setUser } from '../../actions/UserActions';

class LoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: props.initialEmail || '',
      password: '',
      error: '',
      loading: false,
    };
  }

  handleLogin(e) {
    e.preventDefault();
    if (!this.state.email || !this.state.password) {
      this.setState({ error: 'Please enter email and password' });
      return;
    }
    this.setState({ loading: true, error: '' });
    var self = this;
    request.post(config.apiUrl + 'authenticate')
      .send({ email: this.state.email, password: this.state.password })
      .set('Accept', 'application/json')
      .end(function(error, response) {
        if (!error && response.statusCode >= 200 && response.statusCode <= 304) {
          setUser(response.body.token);
          self.props.onSuccess();
        } else {
          self.setState({ loading: false, error: 'Email or password is invalid' });
        }
      });
  }

  render() {
    var self = this;
    return (
      <div className="seat-selection-modal" onClick={this.props.onClose}>
        <div className="seat-selection-dialog" onClick={function(e) { e.stopPropagation(); }} style={{maxWidth: '420px'}}>
          <div className="seat-selection-content">
            <div className="seat-selection-header">
              <div className="header-left">
                <h2 className="header-title">Log In to Continue</h2>
              </div>
              <div className="header-right">
                <button type="button" className="btn-close" onClick={this.props.onClose} aria-label="Close">
                  <span style={{ fontSize: '24px', lineHeight: 1 }}>&times;</span>
                </button>
              </div>
            </div>
            <div style={{padding: '20px'}}>
              <p style={{margin: '0 0 16px', color: '#666', fontSize: '14px'}}>
                Please log in to your account to make changes to your reservation.
              </p>
              <form onSubmit={this.handleLogin.bind(this)}>
                <div className="form-group">
                  <label className="formLable">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={this.state.email}
                    onChange={function(e) { self.setState({ email: e.target.value, error: '' }); }}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="formLable">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={this.state.password}
                    onChange={function(e) { self.setState({ password: e.target.value, error: '' }); }}
                    required
                  />
                  <Link className="forgot-link" to="/forgot-password" style={{fontSize: '12px', float: 'right', marginTop: '4px'}}>Forgot Password?</Link>
                </div>
                {this.state.error && <div className="error" style={{marginBottom: '10px', clear: 'both'}}>{this.state.error}</div>}
                <button type="submit" className="btn btn-blue btn-block" disabled={this.state.loading} style={{clear: 'both', marginTop: '8px'}}>
                  {this.state.loading ? 'Logging in...' : 'LOG IN'}
                </button>
                <div style={{textAlign: 'center', marginTop: '12px', fontSize: '13px'}}>
                  Not a user yet? <Link to="/registration">Register now.</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginModal;
